import { serializeBareItem } from './serializeBareItem.ts'
import { serializeKey } from './serializeKey.ts'

// 4.1.1.2.  Serializing Parameters
//
// Given an ordered Dictionary as input_parameters (each member having a
// param_name and a param_value), return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each param_name with a value of param_value in
//     input_parameters:
//
//     1.  Append ";" to output.
//
//     2.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with param_name to output.
//
//     3.  If param_value is not Boolean true:
//
//         1.  Append "=" to output.
//
//         2.  Append the result of running Serializing a bare Item
//             (Section 4.1.3.1) with param_value to output.
//
// 3.  Return output.
/**
 * @internal
 */
export function serializeParams(params?: Record<string, any>): string {
	if (params == null) {
		return ''
	}

	let output = ''

	for (const key of Object.keys(params)) {
		const value = params[key]
		output += `;${serializeKey(key)}`

		if (value !== true) { // omit true
			output += `=${serializeBareItem(value)}`
		}
	}

	return output
}
